import axios from 'axios';

const api = axios.create({
  baseURL: 'https://inova3d-service.funifier.com/v3/',
});

export default api;
